const translations = {
  en: {
    // Welcome
    welcome_admin_title: "Administration Panel",
    welcome_admin_sub: "Admin Panel",
    welcome_admin_desc: "Manage employees, attendance, payroll, shifts & reports",
    welcome_emp_title: "Employee Panel",
    welcome_emp_sub: "Employee Panel",
    welcome_emp_desc: "Check in/out, view schedule, request leave",
    welcome_install: "Install App",
    welcome_install_hint: "Add to Home Screen from browser menu to install",

    // Login
    login_title: "Sign In",
    login_subtitle: "Secure access to hospital operations",
    login_username: "Username",
    login_password: "Password",
    login_btn: "Sign In",
    login_emp_link: "Employee Panel",
    login_back: "Back",

    // Employee Login
    emp_login_title: "Employee Login",
    emp_login_subtitle: "Enter your code and PIN to access",
    emp_login_code: "Employee Code",
    emp_login_pin: "PIN",
    emp_login_btn: "Sign In",
    emp_login_admin_link: "Admin Login",
    emp_login_back: "Back",

    // Sidebar / Nav
    nav_dashboard: "Dashboard",
    nav_employees: "Employees",
    nav_attendance: "Attendance",
    nav_payroll: "Payroll",
    nav_alerts: "Alerts",
    nav_leave: "Leave Requests",
    nav_shifts: "Shift Schedule",
    nav_settings: "Settings",
    nav_users: "Users",
    nav_audit: "Audit Trail",
    nav_logout: "Logout",

    // Dashboard
    dash_title: "Dashboard",
    dash_total_emp: "Total Employees",
    dash_present: "Present Today",
    dash_absent: "Absent Today",
    dash_hours: "Hours Today",
    dash_payroll: "Monthly Payroll",
    dash_late: "Late Arrivals",
    dash_pending_leaves: "Pending Leaves",
    dash_daily_hours: "Daily Hours (Last 7 Working Days)",
    dash_dept_payroll: "Payroll by Department",
    dash_quick_actions: "Quick Actions",
    dash_recent: "Recent Activity",
    dash_load_demo: "Load Demo Data",

    // Employees
    emp_title: "Employees",
    emp_add: "Add Employee",
    emp_search: "Search by name, department, code...",
    emp_name: "Employee",
    emp_code: "Code",
    emp_card: "Card UID",
    emp_dept: "Department",
    emp_position: "Position",
    emp_shift: "Shift",
    emp_rate: "Rate",
    emp_status: "Status",
    emp_actions: "Actions",
    emp_active: "Active",
    emp_inactive: "Inactive",
    emp_full_name: "Full Name",
    emp_hourly_rate: "Hourly Rate (ALL)",
    emp_annual_leave: "Annual Leave Days",
    emp_carried_over: "Carried Over Days",
    emp_pin: "PIN",
    emp_save: "Save",
    emp_create_title: "Add New Employee",
    emp_edit_title: "Edit Employee",
    emp_no_employees: "No employees found",

    // Payroll
    pay_title: "Monthly Payroll",
    pay_subtitle: "Salary calculations based on attendance",
    pay_days: "Days Worked",
    pay_hours: "Regular Hours",
    pay_overtime: "Overtime",
    pay_total: "Grand Total",
    pay_export: "Export",
    pay_employee: "Employee",
    pay_ot: "OT",
    pay_rate: "Rate",
    pay_regular: "Regular",
    pay_ot_pay: "OT Pay",
    pay_no_data: "No payroll data for this period",
    pay_details: "Details",
    pay_employees: "employees",

    // Attendance
    att_title: "Attendance",
    att_subtitle: "Real-time attendance tracking",
    att_today: "Today",
    att_history: "History",
    att_manual: "Manual Entry",
    att_time: "Time",
    att_type: "Type",
    att_source: "Source",
    att_employee: "Employee",
    att_select_emp: "Select Employee",
    att_select_type: "Select Type",
    att_check_in: "Check In",
    att_check_out: "Check Out",
    att_record: "Record",
    att_no_records: "No attendance records",
    att_month: "Month",
    att_year: "Year",

    // Alerts
    alert_title: "Alerts & Flags",
    alert_subtitle: "Missing check-outs, late arrivals, and anomalies",
    alert_no_alerts: "No alerts for this date",
    alert_missing_checkout: "Missing Checkout",
    alert_late_arrival: "Late Arrival",
    alert_early_exit: "Early Exit",
    alert_high: "High",
    alert_medium: "Medium",
    alert_low: "Low",

    // Leave
    leave_title: "Leave Requests",
    leave_subtitle: "Manage employee annual leave and time-off requests",
    leave_pending: "Pending",
    leave_approved: "Approved",
    leave_rejected: "Rejected",
    leave_approve_btn: "Approve",
    leave_reject_btn: "Reject",
    leave_all: "All",
    leave_employee: "Employee",
    leave_start: "Start",
    leave_end: "End",
    leave_days: "Days",
    leave_type: "Type",
    leave_reason: "Reason",
    leave_status: "Status",
    leave_no_requests: "No leave requests",
    leave_annual: "Annual",
    leave_carried: "Carried Over",
    leave_sick: "Sick",
    leave_personal: "Personal",
    leave_reviewed: "Reviewed",

    // Shifts
    shift_title: "Shift Schedule",
    shift_subtitle: "Employee shift assignments and schedule overview",
    shift_name: "Shift Name",
    shift_time: "Time",
    shift_hours: "Hours",
    shift_employees: "Employees",
    shift_all_shifts: "All Shifts",
    shift_no_employees: "No employees assigned",

    // Settings
    settings_title: "Settings",
    settings_subtitle: "System configuration and geofence settings",
    settings_geofence: "GPS Geofence",
    settings_enabled: "Geofence Active",
    settings_disabled: "Geofence Disabled",
    settings_lat: "Latitude",
    settings_lng: "Longitude",
    settings_radius: "Radius (meters)",
    settings_address: "Address",
    settings_save: "Save Settings",
    settings_employees_must: "Employees must be within",
    settings_of_base: "of the base point to check in/out",
    settings_no_restriction: "No location restriction for check-in/out",

    // Users
    users_title: "User Management",
    users_subtitle: "Manage admin, HR, and viewer accounts",
    users_add: "Add User",
    users_email: "Email",
    users_name: "Full Name",
    users_role: "Role",
    users_created: "Created",
    users_no_users: "No users found",

    // Audit
    audit_title: "Audit Trail",
    audit_subtitle: "System activity log",
    audit_action: "Action",
    audit_resource: "Resource",
    audit_user: "User",
    audit_time: "Time",
    audit_no_logs: "No audit logs",

    // Employee Portal
    portal_logout: "Logout",
    portal_your_shift: "Your Shift",
    portal_gps_active: "GPS active",
    portal_radius: "Radius",
    portal_check_in: "Entry",
    portal_check_out: "Exit",
    portal_code: "Code",
    portal_hours_month: "Hours This Month",
    portal_today_tab: "Today",
    portal_profile_tab: "Profile",
    portal_hours_tab: "Hours",
    portal_shifts_tab: "Shifts",
    portal_leave_tab: "Leave",
    portal_today_activity: "Today's Activity",
    portal_no_data: "No data",
    portal_in: "IN",
    portal_out: "OUT",
    portal_my_profile: "My Profile",
    portal_edit: "Edit",
    portal_save: "Save",
    portal_cancel: "Cancel",
    portal_full_name: "Full Name",
    portal_emp_code: "Employee Code",
    portal_department: "Department",
    portal_position: "Position",
    portal_contact_info: "Contact Information",
    portal_phone: "Phone",
    portal_email: "Email",
    portal_address: "Address",
    portal_change_pin: "Change PIN",
    portal_update_pin: "Update your login PIN",
    portal_current_pin: "Current PIN",
    portal_new_pin: "New PIN",
    portal_confirm_pin: "Confirm New PIN",
    portal_work_hours: "Work Hours History",
    portal_days_worked: "Days Worked",
    portal_normal_hours: "Normal Hours",
    portal_overtime_hours: "Overtime Hours",
    portal_date: "Date",
    portal_entry: "Entry",
    portal_exit: "Exit",
    portal_hours: "Hours",
    portal_overtime: "Overtime",
    portal_status: "Status",
    portal_complete: "COMPLETE",
    portal_incomplete: "INCOMPLETE",
    portal_shift_calendar: "Shift Calendar",
    portal_current_shift: "Your current shift",
    portal_weekend: "Off",
    portal_legend_complete: "Complete",
    portal_legend_incomplete: "Incomplete",
    portal_legend_weekend: "Weekend",
    portal_legend_today: "Today",
    portal_annual_leave: "Annual Leave",
    portal_annual_days: "Annual Days",
    portal_carried_days: "Carried Over",
    portal_total_available: "Total",
    portal_used_days: "Used",
    portal_remaining_days: "Remaining",
    portal_request_leave: "Request Leave",
    portal_my_requests: "My Requests",
    portal_start_date: "Start Date",
    portal_end_date: "End Date",
    portal_reason: "Reason",
    portal_leave_type: "Leave Type",
    portal_annual: "Annual",
    portal_carried: "Carried Over",
    portal_sick: "Sick",
    portal_personal: "Personal",
    portal_submit: "Submit",
    portal_pending: "Pending",
    portal_approved: "Approved",
    portal_rejected: "Rejected",
    portal_days: "days",
    portal_no_requests: "No requests",
    portal_checkin_ok: "Check-in recorded!",
    portal_checkout_ok: "Check-out recorded!",
    portal_profile_saved: "Profile updated!",
    portal_pin_changed: "PIN changed successfully!",
    portal_pin_mismatch: "PINs do not match!",
    portal_pin_short: "PIN must be at least 4 digits",
    portal_fill_dates: "Please fill in the dates",
    portal_leave_sent: "Leave request sent!",
    portal_optional: "Optional...",
    portal_hours_label: "hours",
    portal_ore: "h",

    // Days of week short
    day_mon: "Mon",
    day_tue: "Tue",
    day_wed: "Wed",
    day_thu: "Thu",
    day_fri: "Fri",
    day_sat: "Sat",
    day_sun: "Sun",

    // Months
    month_1: "January", month_2: "February", month_3: "March", month_4: "April",
    month_5: "May", month_6: "June", month_7: "July", month_8: "August",
    month_9: "September", month_10: "October", month_11: "November", month_12: "December",

    // Common
    common_save: "Save",
    common_cancel: "Cancel",
    common_delete: "Delete",
    common_edit: "Edit",
    common_create: "Create",
    common_details: "Details",
    common_no_data: "No data",
    common_loading: "Loading...",
    common_made_by: "",
    common_welcome: "Welcome!",
  },

  sq: {
    // Welcome
    welcome_admin_title: "Paneli i Administratorit",
    welcome_admin_sub: "Administration Panel",
    welcome_admin_desc: "Menaxho punonjësit, prezencën, pagat, turnet & raportet",
    welcome_emp_title: "Paneli i Punonjësve",
    welcome_emp_sub: "Employee Panel",
    welcome_emp_desc: "Hyrje/dalje, shiko orarin, kërko leje",
    welcome_install: "Instalo Aplikacionin",
    welcome_install_hint: "Shtoni në ekranin kryesor nga menuja e browser-it",

    // Login
    login_title: "Hyrje",
    login_subtitle: "Akses i sigurt në operacionet e spitalit",
    login_username: "Emri i përdoruesit",
    login_password: "Fjalëkalimi",
    login_btn: "Hyr në Sistem",
    login_emp_link: "Paneli i Punonjësve",
    login_back: "Kthehu",
    login_username_placeholder: "p.sh. emrimbiemri",
    login_password_placeholder: "Fjalëkalimi",
    login_remember_me: "Më mba mend për 7 ditë",
    login_use_credentials: "Përdorni kredencialet tuaja për të vazhduar",
    login_footer: "© 2026 Spitali Gjerman · Sistem i menaxhimit",

    // Employee Login
    emp_login_title: "Hyrja e Punonjësit",
    emp_login_subtitle: "Vendosni kodin tuaj dhe PIN-in për të hyrë",
    emp_login_code: "Kodi i Punonjësit",
    emp_login_pin: "PIN",
    emp_login_btn: "Hyr",
    emp_login_admin_link: "Hyrja e Administratorit",
    emp_login_back: "Kthehu",

    // Sidebar / Nav
    nav_dashboard: "Paneli Kryesor",
    nav_employees: "Punonjësit",
    nav_attendance: "Prezenca",
    nav_payroll: "Pagat",
    nav_alerts: "Njoftimet",
    nav_leave: "Kërkesat për Leje",
    nav_shifts: "Orari i Turneve",
    nav_settings: "Cilësimet",
    nav_users: "Përdoruesit",
    nav_audit: "Gjurmimi",
    nav_logout: "Dil",

    // Dashboard
    dash_title: "Paneli Kryesor",
    dash_total_emp: "Punonjës Gjithsej",
    dash_present: "Prezent Sot",
    dash_absent: "Mungojnë Sot",
    dash_hours: "Orë Sot",
    dash_payroll: "Paga Mujore",
    dash_late: "Vonesa",
    dash_pending_leaves: "Leje në Pritje",
    dash_daily_hours: "Orët Ditore (7 Ditët e Fundit)",
    dash_dept_payroll: "Pagat sipas Departamentit",
    dash_quick_actions: "Veprime të Shpejta",
    dash_recent: "Aktiviteti i Fundit",
    dash_load_demo: "Ngarko Demo",

    // Employees
    emp_title: "Punonjësit",
    emp_add: "Shto Punonjës",
    emp_search: "Kërko sipas emrit, departamentit, kodit...",
    emp_name: "Punonjësi",
    emp_code: "Kodi",
    emp_card: "Karta UID",
    emp_dept: "Departamenti",
    emp_position: "Pozicioni",
    emp_shift: "Turni",
    emp_rate: "Paga/orë",
    emp_status: "Statusi",
    emp_actions: "Veprimet",
    emp_active: "Aktiv",
    emp_inactive: "Joaktiv",
    emp_full_name: "Emri i Plotë",
    emp_hourly_rate: "Paga për Orë (ALL)",
    emp_annual_leave: "Ditë Leje Vjetore",
    emp_carried_over: "Ditë Bartura",
    emp_pin: "PIN",
    emp_save: "Ruaj",
    emp_create_title: "Shto Punonjës të Ri",
    emp_edit_title: "Ndrysho Punonjësin",
    emp_no_employees: "Nuk u gjetën punonjës",

    // Payroll
    pay_title: "Pagat Mujore",
    pay_subtitle: "Llogaritja e pagave sipas prezencës",
    pay_days: "Ditë Punuara",
    pay_hours: "Orë Normale",
    pay_overtime: "Orë Shtesë",
    pay_total: "Gjithsej",
    pay_export: "Eksporto",
    pay_employee: "Punonjësi",
    pay_ot: "Shtesë",
    pay_rate: "Paga",
    pay_regular: "Normale",
    pay_ot_pay: "Paga Shtesë",
    pay_no_data: "Nuk ka të dhëna për këtë periudhë",
    pay_details: "Detaje",
    pay_employees: "punonjës",

    // Attendance
    att_title: "Prezenca",
    att_subtitle: "Gjurmimi i prezencës në kohë reale",
    att_today: "Sot",
    att_history: "Historiku",
    att_manual: "Hyrje Manuale",
    att_time: "Ora",
    att_type: "Lloji",
    att_source: "Burimi",
    att_employee: "Punonjësi",
    att_select_emp: "Zgjidhni Punonjësin",
    att_select_type: "Zgjidhni Llojin",
    att_check_in: "Hyrje",
    att_check_out: "Dalje",
    att_record: "Regjistro",
    att_no_records: "Nuk ka regjistrime",
    att_month: "Muaji",
    att_year: "Viti",

    // Alerts
    alert_title: "Njoftimet & Sinjalet",
    alert_subtitle: "Mungesa dalje, vonesa, dhe anomali",
    alert_no_alerts: "Nuk ka njoftime për këtë datë",
    alert_missing_checkout: "Mungon Dalja",
    alert_late_arrival: "Vonesë",
    alert_early_exit: "Dalje e Hershme",
    alert_high: "E Lartë",
    alert_medium: "Mesatare",
    alert_low: "E Ulët",

    // Leave
    leave_title: "Kërkesat për Leje",
    leave_subtitle: "Menaxho lejet vjetore dhe pushimet",
    leave_pending: "Në Pritje",
    leave_approved: "Aprovuar",
    leave_rejected: "Refuzuar",
    leave_approve_btn: "Aprovo",
    leave_reject_btn: "Refuzo",
    leave_all: "Të Gjitha",
    leave_employee: "Punonjësi",
    leave_start: "Fillimi",
    leave_end: "Mbarimi",
    leave_days: "Ditë",
    leave_type: "Lloji",
    leave_reason: "Arsyeja",
    leave_status: "Statusi",
    leave_no_requests: "Nuk ka kërkesa",
    leave_annual: "Vjetore",
    leave_carried: "Bartura",
    leave_sick: "Sëmundje",
    leave_personal: "Personale",
    leave_reviewed: "Shqyrtuar",

    // Shifts
    shift_title: "Orari i Turneve",
    shift_subtitle: "Caktimet e turneve dhe pamja e orarit",
    shift_name: "Emri i Turnit",
    shift_time: "Ora",
    shift_hours: "Orë",
    shift_employees: "Punonjës",
    shift_all_shifts: "Të Gjitha Turnet",
    shift_no_employees: "Nuk ka punonjës të caktuar",

    // Settings
    settings_title: "Cilësimet",
    settings_subtitle: "Konfigurimi i sistemit dhe GPS",
    settings_geofence: "GPS Geofence",
    settings_enabled: "Geofence Aktiv",
    settings_disabled: "Geofence Çaktivizuar",
    settings_lat: "Gjerësia Gjeografike",
    settings_lng: "Gjatësia Gjeografike",
    settings_radius: "Rrezja (metra)",
    settings_address: "Adresa",
    settings_save: "Ruaj Cilësimet",
    settings_employees_must: "Punonjësit duhet të jenë brenda",
    settings_of_base: "nga pika bazë për hyrje/dalje",
    settings_no_restriction: "Nuk ka kufizim vendndodhjeje për hyrje/dalje",

    // Users
    users_title: "Menaxhimi i Përdoruesve",
    users_subtitle: "Menaxho llogaritë admin, HR dhe viewer",
    users_add: "Shto Përdorues",
    users_email: "Email",
    users_name: "Emri i Plotë",
    users_role: "Roli",
    users_created: "Krijuar",
    users_no_users: "Nuk u gjetën përdorues",

    // Audit
    audit_title: "Gjurmimi i Aktivitetit",
    audit_subtitle: "Regjistri i aktivitetit të sistemit",
    audit_action: "Veprimi",
    audit_resource: "Resursi",
    audit_user: "Përdoruesi",
    audit_time: "Koha",
    audit_no_logs: "Nuk ka regjistrime",

    // Employee Portal
    portal_logout: "Dil",
    portal_your_shift: "Turni Juaj",
    portal_gps_active: "GPS aktiv",
    portal_radius: "Rreze",
    portal_check_in: "Hyrja",
    portal_check_out: "Dalja",
    portal_code: "Kodi",
    portal_hours_month: "Orët këtë Muaj",
    portal_today_tab: "Sot",
    portal_profile_tab: "Profili",
    portal_hours_tab: "Orët",
    portal_shifts_tab: "Turnet",
    portal_leave_tab: "Leje",
    portal_today_activity: "Aktiviteti i Sotëm",
    portal_no_data: "Nuk ka të dhëna",
    portal_in: "HYRJE",
    portal_out: "DALJE",
    portal_my_profile: "Profili Im",
    portal_edit: "Ndrysho",
    portal_save: "Ruaj",
    portal_cancel: "Anulo",
    portal_full_name: "Emri i Plotë",
    portal_emp_code: "Kodi i Punonjësit",
    portal_department: "Departamenti",
    portal_position: "Pozicioni",
    portal_contact_info: "Informacione Kontakti",
    portal_phone: "Telefoni",
    portal_email: "Email",
    portal_address: "Adresa",
    portal_change_pin: "Ndrysho PIN-in",
    portal_update_pin: "Përditëso PIN-in e hyrjes",
    portal_current_pin: "PIN-i Aktual",
    portal_new_pin: "PIN-i i Ri",
    portal_confirm_pin: "Konfirmo PIN-in e Ri",
    portal_work_hours: "Historiku i Orëve të Punës",
    portal_days_worked: "Ditë Punuara",
    portal_normal_hours: "Orë Normale",
    portal_overtime_hours: "Orë Shtesë",
    portal_date: "Data",
    portal_entry: "Hyrja",
    portal_exit: "Dalja",
    portal_hours: "Orë",
    portal_overtime: "Shtesë",
    portal_status: "Statusi",
    portal_complete: "E PLOTË",
    portal_incomplete: "E PAPLOTË",
    portal_shift_calendar: "Kalendari i Turneve",
    portal_current_shift: "Turni juaj aktual",
    portal_weekend: "Pushim",
    portal_legend_complete: "E plotë",
    portal_legend_incomplete: "E paplotë",
    portal_legend_weekend: "Pushim",
    portal_legend_today: "Sot",
    portal_annual_leave: "Leja Vjetore",
    portal_annual_days: "Ditë Vjetore",
    portal_carried_days: "Ditë Bartura",
    portal_total_available: "Gjithsej",
    portal_used_days: "Përdorura",
    portal_remaining_days: "Mbetur",
    portal_request_leave: "Kërko Leje",
    portal_my_requests: "Kërkesat e Mia",
    portal_start_date: "Data e Fillimit",
    portal_end_date: "Data e Mbarimit",
    portal_reason: "Arsyeja",
    portal_leave_type: "Lloji i Lejes",
    portal_annual: "Vjetore",
    portal_carried: "Bartura",
    portal_sick: "Sëmundje",
    portal_personal: "Personale",
    portal_submit: "Dërgo",
    portal_pending: "Në Pritje",
    portal_approved: "Aprovuar",
    portal_rejected: "Refuzuar",
    portal_days: "ditë",
    portal_no_requests: "Nuk ka kërkesa",
    portal_checkin_ok: "Hyrja u regjistrua!",
    portal_checkout_ok: "Dalja u regjistrua!",
    portal_profile_saved: "Profili u përditësua!",
    portal_pin_changed: "PIN-i u ndryshua me sukses!",
    portal_pin_mismatch: "PIN-et nuk përputhen!",
    portal_pin_short: "PIN duhet të ketë 4+ shifra",
    portal_fill_dates: "Ju lutem plotësoni datat",
    portal_leave_sent: "Kërkesa u dërgua!",
    portal_optional: "Opsionale...",
    portal_hours_label: "orë",
    portal_ore: "h",

    // Days of week short
    day_mon: "Hën",
    day_tue: "Mar",
    day_wed: "Mër",
    day_thu: "Enj",
    day_fri: "Pre",
    day_sat: "Sht",
    day_sun: "Die",

    // Months
    month_1: "Janar", month_2: "Shkurt", month_3: "Mars", month_4: "Prill",
    month_5: "Maj", month_6: "Qershor", month_7: "Korrik", month_8: "Gusht",
    month_9: "Shtator", month_10: "Tetor", month_11: "Nëntor", month_12: "Dhjetor",

    // Common
    common_save: "Ruaj",
    common_cancel: "Anulo",
    common_delete: "Fshi",
    common_edit: "Ndrysho",
    common_create: "Krijo",
    common_details: "Detaje",
    common_no_data: "Nuk ka të dhëna",
    common_loading: "Duke ngarkuar...",
    common_made_by: "",
    common_welcome: "Mirë se vini!",
  },

  it: {
    // Welcome
    welcome_admin_title: "Pannello di Amministrazione",
    welcome_admin_sub: "Pannello Admin",
    welcome_admin_desc: "Gestisci dipendenti, presenze, paghe, turni & report",
    welcome_emp_title: "Pannello Dipendenti",
    welcome_emp_sub: "Pannello Dipendenti",
    welcome_emp_desc: "Entrata/uscita, vedi orario, richiedi ferie",
    welcome_install: "Installa App",
    welcome_install_hint: "Aggiungi alla schermata Home dal menu del browser",

    // Login
    login_title: "Accedi",
    login_subtitle: "Accesso sicuro alle operazioni ospedaliere",
    login_username: "Nome utente",
    login_password: "Password",
    login_btn: "Accedi",
    login_emp_link: "Pannello Dipendenti",
    login_back: "Indietro",
    login_username_placeholder: "es. nomecognome",
    login_password_placeholder: "Password",
    login_remember_me: "Ricordami per 7 giorni",
    login_use_credentials: "Usa le tue credenziali per continuare",
    login_footer: "© 2026 Spitali Gjerman · Sistema di gestione",

    // Employee Login
    emp_login_title: "Accesso Dipendente",
    emp_login_subtitle: "Inserisci codice e PIN per accedere",
    emp_login_code: "Codice Dipendente",
    emp_login_pin: "PIN",
    emp_login_btn: "Accedi",
    emp_login_admin_link: "Accesso Admin",
    emp_login_back: "Indietro",

    // Sidebar / Nav
    nav_dashboard: "Dashboard",
    nav_employees: "Dipendenti",
    nav_attendance: "Presenze",
    nav_payroll: "Paghe",
    nav_alerts: "Avvisi",
    nav_leave: "Richieste Ferie",
    nav_shifts: "Pianificazione Turni",
    nav_settings: "Impostazioni",
    nav_users: "Utenti",
    nav_audit: "Registro Attività",
    nav_logout: "Esci",

    // Dashboard
    dash_title: "Dashboard",
    dash_total_emp: "Dipendenti Totali",
    dash_present: "Presenti Oggi",
    dash_absent: "Assenti Oggi",
    dash_hours: "Ore Oggi",
    dash_payroll: "Paghe Mensili",
    dash_late: "Ritardi",
    dash_pending_leaves: "Ferie in Attesa",
    dash_daily_hours: "Ore Giornaliere (Ultimi 7 Giorni Lavorativi)",
    dash_dept_payroll: "Paghe per Dipartimento",
    dash_quick_actions: "Azioni Rapide",
    dash_recent: "Attività Recente",
    dash_load_demo: "Carica Demo",

    // Employees
    emp_title: "Dipendenti",
    emp_add: "Aggiungi Dipendente",
    emp_search: "Cerca per nome, dipartimento, codice...",
    emp_name: "Dipendente",
    emp_code: "Codice",
    emp_card: "UID Carta",
    emp_dept: "Dipartimento",
    emp_position: "Posizione",
    emp_shift: "Turno",
    emp_rate: "Tariffa",
    emp_status: "Stato",
    emp_actions: "Azioni",
    emp_active: "Attivo",
    emp_inactive: "Inattivo",
    emp_full_name: "Nome Completo",
    emp_hourly_rate: "Tariffa Oraria (ALL)",
    emp_annual_leave: "Giorni di Ferie Annuali",
    emp_carried_over: "Giorni Riportati",
    emp_pin: "PIN",
    emp_save: "Salva",
    emp_create_title: "Aggiungi Nuovo Dipendente",
    emp_edit_title: "Modifica Dipendente",
    emp_no_employees: "Nessun dipendente trovato",

    // Payroll
    pay_title: "Paghe Mensili",
    pay_subtitle: "Calcolo paghe basato sulle presenze",
    pay_days: "Giorni Lavorati",
    pay_hours: "Ore Regolari",
    pay_overtime: "Straordinari",
    pay_total: "Totale",
    pay_export: "Esporta",
    pay_employee: "Dipendente",
    pay_ot: "Straord.",
    pay_rate: "Tariffa",
    pay_regular: "Regolari",
    pay_ot_pay: "Paga Straord.",
    pay_no_data: "Nessun dato per questo periodo",
    pay_details: "Dettagli",
    pay_employees: "dipendenti",

    // Attendance
    att_title: "Presenze",
    att_subtitle: "Tracciamento presenze in tempo reale",
    att_today: "Oggi",
    att_history: "Storico",
    att_manual: "Inserimento Manuale",
    att_time: "Ora",
    att_type: "Tipo",
    att_source: "Origine",
    att_employee: "Dipendente",
    att_select_emp: "Seleziona Dipendente",
    att_select_type: "Seleziona Tipo",
    att_check_in: "Entrata",
    att_check_out: "Uscita",
    att_record: "Registra",
    att_no_records: "Nessuna registrazione",
    att_month: "Mese",
    att_year: "Anno",

    // Alerts
    alert_title: "Avvisi & Segnalazioni",
    alert_subtitle: "Uscite mancanti, ritardi e anomalie",
    alert_no_alerts: "Nessun avviso per questa data",
    alert_missing_checkout: "Uscita Mancante",
    alert_late_arrival: "Arrivo in Ritardo",
    alert_early_exit: "Uscita Anticipata",
    alert_high: "Alto",
    alert_medium: "Medio",
    alert_low: "Basso",

    // Leave
    leave_title: "Richieste Ferie",
    leave_subtitle: "Gestisci ferie annuali e richieste di permesso",
    leave_pending: "In Attesa",
    leave_approved: "Approvato",
    leave_rejected: "Rifiutato",
    leave_approve_btn: "Approva",
    leave_reject_btn: "Rifiuta",
    leave_all: "Tutte",
    leave_employee: "Dipendente",
    leave_start: "Inizio",
    leave_end: "Fine",
    leave_days: "Giorni",
    leave_type: "Tipo",
    leave_reason: "Motivo",
    leave_status: "Stato",
    leave_no_requests: "Nessuna richiesta",
    leave_annual: "Annuale",
    leave_carried: "Riportato",
    leave_sick: "Malattia",
    leave_personal: "Personale",
    leave_reviewed: "Esaminato",

    // Shifts
    shift_title: "Pianificazione Turni",
    shift_subtitle: "Assegnazioni turni e panoramica",
    shift_name: "Nome Turno",
    shift_time: "Ora",
    shift_hours: "Ore",
    shift_employees: "Dipendenti",
    shift_all_shifts: "Tutti i Turni",
    shift_no_employees: "Nessun dipendente assegnato",

    // Settings
    settings_title: "Impostazioni",
    settings_subtitle: "Configurazione sistema e GPS",
    settings_geofence: "GPS Geofence",
    settings_enabled: "Geofence Attivo",
    settings_disabled: "Geofence Disattivato",
    settings_lat: "Latitudine",
    settings_lng: "Longitudine",
    settings_radius: "Raggio (metri)",
    settings_address: "Indirizzo",
    settings_save: "Salva Impostazioni",
    settings_employees_must: "I dipendenti devono essere entro",
    settings_of_base: "dal punto base per entrare/uscire",
    settings_no_restriction: "Nessuna restrizione di posizione per entrata/uscita",

    // Users
    users_title: "Gestione Utenti",
    users_subtitle: "Gestisci account admin, HR e viewer",
    users_add: "Aggiungi Utente",
    users_email: "Email",
    users_name: "Nome Completo",
    users_role: "Ruolo",
    users_created: "Creato",
    users_no_users: "Nessun utente trovato",

    // Audit
    audit_title: "Registro Attività",
    audit_subtitle: "Log dell'attività del sistema",
    audit_action: "Azione",
    audit_resource: "Risorsa",
    audit_user: "Utente",
    audit_time: "Ora",
    audit_no_logs: "Nessun log",

    // Employee Portal
    portal_logout: "Esci",
    portal_your_shift: "Il Tuo Turno",
    portal_gps_active: "GPS attivo",
    portal_radius: "Raggio",
    portal_check_in: "Entrata",
    portal_check_out: "Uscita",
    portal_code: "Codice",
    portal_hours_month: "Ore Questo Mese",
    portal_today_tab: "Oggi",
    portal_profile_tab: "Profilo",
    portal_hours_tab: "Ore",
    portal_shifts_tab: "Turni",
    portal_leave_tab: "Ferie",
    portal_today_activity: "Attività di Oggi",
    portal_no_data: "Nessun dato",
    portal_in: "ENTRATA",
    portal_out: "USCITA",
    portal_my_profile: "Il Mio Profilo",
    portal_edit: "Modifica",
    portal_save: "Salva",
    portal_cancel: "Annulla",
    portal_full_name: "Nome Completo",
    portal_emp_code: "Codice Dipendente",
    portal_department: "Dipartimento",
    portal_position: "Posizione",
    portal_contact_info: "Informazioni di Contatto",
    portal_phone: "Telefono",
    portal_email: "Email",
    portal_address: "Indirizzo",
    portal_change_pin: "Cambia PIN",
    portal_update_pin: "Aggiorna il PIN di accesso",
    portal_current_pin: "PIN Attuale",
    portal_new_pin: "Nuovo PIN",
    portal_confirm_pin: "Conferma Nuovo PIN",
    portal_work_hours: "Storico Ore Lavorate",
    portal_days_worked: "Giorni Lavorati",
    portal_normal_hours: "Ore Normali",
    portal_overtime_hours: "Ore Straordinarie",
    portal_date: "Data",
    portal_entry: "Entrata",
    portal_exit: "Uscita",
    portal_hours: "Ore",
    portal_overtime: "Straord.",
    portal_status: "Stato",
    portal_complete: "COMPLETO",
    portal_incomplete: "INCOMPLETO",
    portal_shift_calendar: "Calendario Turni",
    portal_current_shift: "Il tuo turno attuale",
    portal_weekend: "Riposo",
    portal_legend_complete: "Completo",
    portal_legend_incomplete: "Incompleto",
    portal_legend_weekend: "Weekend",
    portal_legend_today: "Oggi",
    portal_annual_leave: "Ferie Annuali",
    portal_annual_days: "Giorni Annuali",
    portal_carried_days: "Riportati",
    portal_total_available: "Totale",
    portal_used_days: "Usati",
    portal_remaining_days: "Rimanenti",
    portal_request_leave: "Richiedi Ferie",
    portal_my_requests: "Le Mie Richieste",
    portal_start_date: "Data Inizio",
    portal_end_date: "Data Fine",
    portal_reason: "Motivo",
    portal_leave_type: "Tipo di Ferie",
    portal_annual: "Annuale",
    portal_carried: "Riportato",
    portal_sick: "Malattia",
    portal_personal: "Personale",
    portal_submit: "Invia",
    portal_pending: "In Attesa",
    portal_approved: "Approvato",
    portal_rejected: "Rifiutato",
    portal_days: "giorni",
    portal_no_requests: "Nessuna richiesta",
    portal_checkin_ok: "Entrata registrata!",
    portal_checkout_ok: "Uscita registrata!",
    portal_profile_saved: "Profilo aggiornato!",
    portal_pin_changed: "PIN cambiato con successo!",
    portal_pin_mismatch: "I PIN non corrispondono!",
    portal_pin_short: "Il PIN deve avere almeno 4 cifre",
    portal_fill_dates: "Compila le date",
    portal_leave_sent: "Richiesta inviata!",
    portal_optional: "Opzionale...",
    portal_hours_label: "ore",
    portal_ore: "h",

    // Days of week short
    day_mon: "Lun",
    day_tue: "Mar",
    day_wed: "Mer",
    day_thu: "Gio",
    day_fri: "Ven",
    day_sat: "Sab",
    day_sun: "Dom",

    // Months
    month_1: "Gennaio", month_2: "Febbraio", month_3: "Marzo", month_4: "Aprile",
    month_5: "Maggio", month_6: "Giugno", month_7: "Luglio", month_8: "Agosto",
    month_9: "Settembre", month_10: "Ottobre", month_11: "Novembre", month_12: "Dicembre",

    // Common
    common_save: "Salva",
    common_cancel: "Annulla",
    common_delete: "Elimina",
    common_edit: "Modifica",
    common_create: "Crea",
    common_details: "Dettagli",
    common_no_data: "Nessun dato",
    common_loading: "Caricamento...",
    common_made_by: "",
    common_welcome: "Benvenuto!",
  }
};

export default translations;
